<!-- <div class="tabs-dashboard__body second d-none"> -->

  <div class="loader-licenses" *ngIf="requestLoading">
    <app-loader></app-loader>
  </div>

  <p *ngIf="getRequestError !== 'DEFAULT' "> {{ getRequestError }}</p>
  <p *ngIf="!requestLoading && getRequestError === 'DEFAULT' &&  allHistoryRequest.length === 0">No tienes ninguna solicitud realizada recientemente.</p>
<div class="table table--history" *ngIf="!requestLoading && allHistoryRequest.length > 0">
  <div class="thead">
    <div class="tr">
      <div class="th hover-hand" [class.active]="order === 'asset'" (click)="setOrder('asset')">
        <div class="table-head headerTable ">
          <p>Asset</p>
          <div class="sorting-arrows-container">
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'asset' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting ASC -->
              <div [hidden]="(order === 'asset' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'asset' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting DESC -->
              <div [hidden]="(order === 'asset' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="th hover-hand" [class.active]="order === 'resquestType'" (click)="setOrder('resquestType')">
        <div class="table-head headerTable ">
          <p> Tipo </p>
          <div class="sorting-arrows-container">
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'resquestType' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting ASC -->
              <div [hidden]="(order === 'resquestType' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'resquestType' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting DESC -->
              <div [hidden]="(order === 'resquestType' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="th hover-hand" [class.active]="order === 'requirementStatus'" (click)="setOrder('requirementStatus')">
        <div class="table-head headerTable">
          <p>Estado </p>
          <div class="sorting-arrows-container">
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'requirementStatus' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting ASC -->
              <div [hidden]="(order === 'requirementStatus' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'requirementStatus' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting DESC -->
              <div [hidden]="(order === 'requirementStatus' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="th hover-hand" [class.active]="order === 'requirementId'" (click)="setOrder('requirementId')">
        <div class="table-head headerTable ">
          <p> Nº solicitud </p>
          <div class="sorting-arrows-container">
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'requirementId' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting ASC -->
              <div [hidden]="(order === 'requirementId' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'requirementId' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting DESC -->
              <div [hidden]="(order === 'requirementId' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="th hover-hand" [class.active]="order === 'requirementDate'" (click)="setOrder('requirementDate')">
        <div class="table-head headerTable ">
          <p>Fecha solicitud</p>
          <div class="sorting-arrows-container">
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'requirementDate' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting ASC -->
              <div [hidden]="(order === 'requirementDate' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
            <div class="arrow-container">
              <!-- Sorting Disabled -->
              <div [hidden]="!(order === 'requirementDate' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
              </div>
              <!-- Sorting DESC -->
              <div [hidden]="(order === 'requirementDate' && orderStatus === 3)">
                <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="th hover-hand">
        <div class="table-head headerTable">
          Más información
        </div>
      </div>
    </div>
  </div>
  <div class="tbody desktop">
    <div class="tr" *ngFor="let requirement of allHistoryRequest | orderBy: order :reverse : true ">
      <div class="td td--number">
        <p>{{requirement?.asset}}</p>
      </div>
      <div class="td td--button">
        <p>{{requirement?.requestType}} </p>
      </div>
      <div class="td td--status  textContain statusIconRequest">
        <p> <img class="mr-2"
            [src]="imagesStatus[formatStatus(requirement?.requirementStatus)]">{{requirement?.requirementStatus}}</p>
      </div>
      <div class="td td--body">
        <p><span>Número de solicitud: </span>{{requirement?.requirementId}}</p>
      </div>
      <div class="td td--body">
        <p><span>Fecha solicitud: </span>{{requirement?.requirementDate | dateFromBack }}</p>
      </div>
      <div class="td td--body">
        <a class="btn btn--link btn--link--secondary"  routerLink="/verification/requests" [state]="{requestNumberToShow: requirement?.requirementId}">Ver solicitud</a>
      </div>
    </div>

  </div>
  <div class="tbody mobile">
    <div *ngFor="let requirement of allHistoryRequest | orderBy: order :reverse : true ">
      <mat-expansion-panel class="tableRowsResponsive" (opened)="panelOpenState = true"
        (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title class="assetName">
            <div class="containerP">
              <p>{{requirement?.asset}}</p>
            </div>
          </mat-panel-title>
          <mat-panel-description class="descriptionAct">

            <p>{{requirement?.requestType}} </p>

            <div class="statusIconRequest">
              <p class="textDate"> Estado: <img class="mr-2 iconStatus"
                  [src]="imagesStatus[formatStatus(requirement?.requirementStatus)]">{{requirement?.requirementStatus}}
              </p>
            </div>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="bodyDetail">

          <p><span>Número de solicitud: </span>{{requirement?.requirementId}}</p>

          <p><span>Fecha solicitud: </span>{{requirement?.requirementDate | dateFromBack}}</p>

          <p> <a class="textMoreInformationMobile" routerLink="/verification/requests" >Ver solicitud</a></p>
        </div>

      </mat-expansion-panel>
    </div>

  </div>

</div>
<a class="btn btn--link btn--link--secondary btn--link--secondary--big btn--link--secondary--bold btn--link--secondary--color mt-2 pl-0"
  routerLink="/verification/requests" *ngIf="!requestLoading && allHistoryRequest.length > 0" >Ver historial completo de solicitudes</a>
